import DataTableGrid from '@bumble/app/components/DataTableGrid';
import { Loading } from '@bumble/app/components/Loading';
import NoData from '@bumble/app/components/NoData';
import { useApi } from '@bumble/app/hooks/use-api';
import { Box } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { useQuery } from '@tanstack/react-query';
import { toast } from 'react-toastify';

const columns: GridColDef[] = [
  {
    field: 'src_address',
    headerName: 'Src IP',
    flex: 1,
    minWidth: 100,
    disableColumnMenu: true,
  },
  {
    field: 'dst_address',
    headerName: 'Dst IP',
    flex: 1,
    minWidth: 100,
    disableColumnMenu: true,
  },
  {
    field: 'protocol',
    headerName: 'Protocol',
    flex: 1,
    minWidth: 100,
    disableColumnMenu: true,
  },
  {
    field: 'src_port',
    headerName: 'Src Port',
    width: 100,
    disableColumnMenu: true,
  },
  {
    field: 'dst_port',
    headerName: 'Dest Port',
    width: 100,
    disableColumnMenu: true,
  },
  // {
  //   field: 'tx_packets',
  //   headerName: 'TX Packets',
  //   width: 100,
  //   disableColumnMenu: true,
  // },
  {
    field: 'tx_bytes',
    headerName: 'TX Bytes',
    width: 100,
    disableColumnMenu: true,
  },
  // {
  //   field: 'rx_packets',
  //   headerName: 'RX Packets',
  //   width: 100,
  //   disableColumnMenu: true,
  // },
  {
    field: 'rx_bytes',
    headerName: 'RX Bytes',
    width: 100,
    disableColumnMenu: true,
  },
  {
    field: 'established',
    headerName: 'Established',
    width: 100,
    disableColumnMenu: true,
    headerAlign: 'right',
    align: 'right',
  },
];

const columnVisible = {
  dst_address: true,
  src_address: true,
  src_port: true,
  dst_port: true,
  // 'tx_packets': true,
  tx_bytes: true,
  // 'rx_packets': true,
  rx_bytes: true,
  established: true,
};

export const EndpointSources = ({ epId }: { epId: string }) => {
  const api = useApi();

  const { isLoading, data, refetch } = useQuery(
    ['getEndpointSession'],
    api.getEndpointSessionsApiV1GetEndpointSessionsGet.bind(null, {
      ep_id: epId
    }),
    { cacheTime: 0 },
  );

  const handleDataRefetch = () => {
    refetch();
    toast.success('Refreshed flows.');
  };

  const sourcesData = data?.data.map((item, i) => ({
    ...item,
    id: item.src_address + i,
  }));

  if (isLoading) return <Loading />;
  return (
    <Box>
      {sourcesData && sourcesData.length > 0 ? (
        <DataTableGrid rows={sourcesData} columns={columns} columnVisibilityModel={columnVisible} refreshData={handleDataRefetch} />
      ) : (
        <NoData />
      )}
    </Box>
  );
};
